import { modalSectionsConfig } from 'utils/constants';
import { SidebarProps } from 'interfaces/components/dataEntryModal/Sidebar';

const Sidebar = ({ selected, onSectionSelect }: SidebarProps) => {
  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  return (
    <div className='flex flex-col justify-start w-[204px] border-r border-solid border-gray-400 dark:border-gray-800'>
      <div
        className={`w-full py-3 pl-8 cursor-pointer walkthrough-required-info ${
          selected === modalSectionsConfig[0].id
            ? isDarkMode
              ? 'dark:bg-gray-900'
              : 'bg-gray-200'
            : ''
        }`}
        onClick={() => onSectionSelect(modalSectionsConfig[0].id)}
      >
        <p
          className={`text-base font-light ${
            selected !== modalSectionsConfig[0].id && 'text-gray-700'
          }`}
        >
          {modalSectionsConfig[0].label}
        </p>
      </div>

      <div className='flex flex-col justify-start w-full walkthrough-optional-info'>
        {modalSectionsConfig.slice(1).map(section => (
          <div
            key={section.id}
            className={`w-full py-3 pl-8 cursor-pointer ${
              selected === section.id
                ? isDarkMode
                  ? 'dark:bg-gray-900'
                  : 'bg-gray-200'
                : ''
            }`}
            onClick={() => onSectionSelect(section.id)}
          >
            <p
              className={`text-base font-light ${
                selected !== section.id && 'text-gray-700'
              }`}
            >
              {section.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
